<template>
    <div class="picture-preview">
        <div ref="sources" class="preview-sources">
            <img v-for="image in images" :key="image" :src="image" alt="" />
        </div>
        <div class="preview-trigger" @click="show">
            <slot></slot>
        </div>
    </div>
</template>

<script>
import Viewer from 'viewerjs';
import 'viewerjs/dist/viewer.css';

export default {
    props: {
        images: {
            type: Array,
            default: () => []
        },
        initialIndex: {
            type: Number,
            default: 0
        }
    },

    data() {
        return {
            viewer: null
        };
    },

    watch: {
        images() {
            this.$nextTick(() => this.viewer?.update());
        }
    },

    mounted() {
        const viewer = new Viewer(this.$refs.sources, {
            viewed() {
                viewer.zoomTo(1);
            }
        });
        this.viewer = viewer;
    },

    beforeDestroy() {
        this.viewer?.destroy();
    },

    methods: {
        show() {
            if (this.images.length) {
                this.viewer.show();
                this.viewer.view(this.initialIndex);
            }
        }
    }
};
</script>

<style scoped>
.picture-preview {
    cursor: zoom-in;
}

.preview-sources {
    display: none;
}
</style>
